import { setSelectedPaths } from '../State/selectedPaths'

export default (paths) => (dispatch) => {

  dispatch(setSelectedPaths(paths))

}
